/**
 * GlobalSearchModal — okno palety globalnej wyszukiwarki (otwierane skrótem Ctrl+K).
 *
 * Cienka obwoluta: całą logikę i render („środek") trzyma współdzielony `GlobalSearch`
 * (`layout="modal"`). Ten sam komponent renderuje się też inline w górnym pasku
 * (`layout="inline"`). `scope` wybiera źródło danych: tenant (domyślny) lub admin (ITE).
 */

import { Modal } from '@/components/Modal';
import { GlobalSearch, type GlobalSearchScope } from '@/components/tenant/GlobalSearch';

interface GlobalSearchModalProps {
  open: boolean;
  onClose: () => void;
  scope?: GlobalSearchScope;
}

export function GlobalSearchModal({ open, onClose, scope = 'tenant' }: GlobalSearchModalProps) {
  return (
    <Modal open={open} onClose={onClose} size="lg" hideCloseButton>
      <GlobalSearch layout="modal" scope={scope} autoFocus onNavigated={onClose} />
    </Modal>
  );
}
